import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import * as DateHelpers from './DateHelpers';
import { GetQuery, PostQuery } from './Shared';

interface JobScheduleExtendProps {
    scheduleId: number;     
    showModal: boolean;
    hideModal(): void;
    saveModal(): void;
}

//extend Dunny Items
interface ExtendItemDetails {
    jobId: number;
    jobQuoteItemId: number;
    itemId: number;
    item: string;
    itemTypeId: number;
    typeId: number;                 //Install = 1, Pickup = 2
    lastInvoiceEndDate: string;     //need to extend from this date
    weeksToExtend: number;
    startDate: string;
    startDateFormatted: string
    endDate: string;
    endDateFormatted: string;
    frequency: string;      //toilet maintenance frequency
    quantity: number;
    amount: number;
    adminFee: number;
    adminFeeFormatted: string;
    additionalHireRate: number;
    purchaseOrderNumber: string;
}


const JobScheduleExtendPopup = (props: JobScheduleExtendProps) => {
    const initItemDetails: ExtendItemDetails = {
        jobId: 0,
        jobQuoteItemId: 0,
        itemId: -1, 
        item: "",
        itemTypeId: -1,
        typeId: -1,
        lastInvoiceEndDate: "",
        weeksToExtend: 0,
        startDate: "",
        startDateFormatted: "",
        endDate: "",
        endDateFormatted: "",
        frequency: "",
        quantity: 1,
        amount: 0,
        adminFee: 0,
        adminFeeFormatted: "$0.00",
        additionalHireRate: 0,
        purchaseOrderNumber: ""
    };
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [itemDetails, setItemDetails] = React.useState<ExtendItemDetails>(initItemDetails);
    const [extendFree, setExtendFree] = React.useState(false);
    const [extendPeriod, setExtendPeriod] = React.useState(1);      //1 = Weeks, 2 = Days
    const [freeDays, setFreeDays] = React.useState(1);
    const [freeWeeks, setFreeWeeks] = React.useState(1);
    const [freeWeeksReason, setFreeWeeksReason] = React.useState("");
    const [chargeAdminFee, setChargeAdminFee] = React.useState(true);
    const [adminFeeDetails, setAdminFeeDetails] = React.useState({ adminFee: 0, adminFeeFormatted: "$0.00" }); 
    const [saveDisabled, setSaveDisabled] = React.useState(false);

    React.useEffect(() => {
        if (props.showModal && props.scheduleId > 0) {
            getData();
        }
    }, [props.scheduleId]);

    const getData = async () => {
        const apiUrl = 'GetScheduleExtendDetails?ScheduleId=' + props.scheduleId;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setItemDetails(result.data);
            setAdminFeeDetails({ adminFee: result.data.adminFee, adminFeeFormatted: result.data.adminFeeFormatted });
            setLoading(false);
            setSaveDisabled(false);
        }
    }

    const hideModal = () => {
        //reset screen and hide
        var resetItem = resetItemDetails();
        setItemDetails(prevState => ({ ...prevState, resetItem }));
        resetScreen();

        props.hideModal();
    }

    const resetItemDetails = () => {
        var resetItem: ExtendItemDetails = {
            jobId: 0,
            jobQuoteItemId: 0,
            itemId: -1,
            item: "",
            itemTypeId: -1,
            typeId: -1,
            lastInvoiceEndDate: "",
            weeksToExtend: 0,
            startDate: "",
            startDateFormatted: "",
            endDate: "",
            endDateFormatted: "",
            frequency: "",
            quantity: 1,
            adminFee: 0,
            adminFeeFormatted: "$0.00",
            amount: 0,
            additionalHireRate: 0,
            purchaseOrderNumber: ""
        };

        return resetItem;
    }

    const resetScreen = () => {
        setExtendFree(false);
        setExtendPeriod(1);
        setFreeDays(1);
        setFreeWeeks(1);
        setFreeWeeksReason("");
        setChargeAdminFee(true);
        setAdminFeeDetails({ adminFee: 0, adminFeeFormatted: "$0.00" }); 
        setSaveDisabled(false);
    }

    const clearError = (e: any) => {
        var error = errors;
        if (e.target.value) {
            delete error[e.target.name];
            setErrors(error);
        }
    }

    const handleExtendFreeChange = (e: any) => {
        var extendForFree = e.target.checked;
        setExtendFree(extendForFree);
        
        if (extendForFree) {
            updateEndDate(freeWeeks, true);
        } else {
            //reset back to start date
            setItemDetails(prevState => ({ ...prevState, endDate: itemDetails.startDate, endDateFormatted: itemDetails.startDateFormatted }));
        }
    }

    const handleExtendPeriodChange = (e: any) => {

        clearError(e);

        let extPeriod = e.target.value * 1;
        setExtendPeriod(extPeriod);
        setFreeDays(1);
        setFreeWeeks(1);

        let isWeeks = extPeriod === 1;
        updateEndDate(1, isWeeks);
    }

    const handleFreeDaysChange = (e: any) => {
        e.preventDefault();

        clearError(e);

        var value = e.target.value * 1;
        setFreeDays(value);

        updateEndDate(value, false);
    }

    const handleFreeWeeksChange = (e: any) => {
        e.preventDefault();

        clearError(e);

        var value = e.target.value * 1;
        setFreeWeeks(value);

        updateEndDate(value, true);
    }

    const handleAdminFeeChange = (e: any) => {
        var adminFee = e.target.checked;
        if (adminFee) {
            setItemDetails(prevState => ({ ...prevState, adminFee: adminFeeDetails.adminFee, adminFeeFormatted: adminFeeDetails.adminFeeFormatted }));
        } else {
            setItemDetails(prevState => ({ ...prevState, adminFee: 0, adminFeeFormatted: "$0.00" }));
        }
        setChargeAdminFee(adminFee);
    }

    const updateEndDate = (daysweeks: number, isWeeks: boolean) => {
        //calculate new end date
        var days = daysweeks - 1;
        if (isWeeks) {
            days = (daysweeks * 7) - 1; //need to minus 1 as invoice dates are inclusive
        };
        var endDate = DateHelpers.addDaysToDate(itemDetails.startDate, days);
        var endDateFormatted = DateHelpers.formatDate(endDate);
        setItemDetails(prevState => ({ ...prevState, endDate: endDate, endDateFormatted: endDateFormatted }));
    }

    const handleFreeWeeksReasonChange = (e: any) => {
        e.preventDefault();

        clearError(e);
        setFreeWeeksReason(e.target.value);
    }

    const handleHirePeriodChange = (e: any) => {
        e.preventDefault();

        clearError(e);

        var value = e.target.value * 1;
        var hirePeriod = itemDetails.itemTypeId === 50 || itemDetails.itemTypeId === 51 ? value : value * 7;    //need days for calcuating end date for weekly hires
        //fencing we add months rather than days
        var newEndDate = itemDetails.itemTypeId === 50 || itemDetails.itemTypeId === 51 ?
            DateHelpers.addMonthsToDate(itemDetails.startDate, value) :
            DateHelpers.addDaysToDate(itemDetails.startDate, hirePeriod - 1);
        var newEndDateFormatted = DateHelpers.formatDate(newEndDate);
        var price = Number((itemDetails.additionalHireRate * value).toFixed(2));

        setItemDetails(prevState => ({ ...prevState, weeksToExtend: value, endDate: newEndDate, endDateFormatted: newEndDateFormatted, amount: price }));
    }

    const handleAmountChange = (e: any) => {
        e.preventDefault();
        clearError(e);

        var value = Number(e.target.value);
        
        setItemDetails(prevState => ({ ...prevState, amount: value }));
    }

    const handlePoChange = (e: any) => {
        e.preventDefault();
        clearError(e);

        setItemDetails(prevState => ({ ...prevState, purchaseOrderNumber: e.target.value }));
    }

    const validate = () => {
        let error: any = {};
        let formIsValid = true;

        if (extendFree) {
            if (freeWeeks <= 0) {
                formIsValid = false;
                error["freeWeeks"] = "# Weeks must be > 0!";
            }

            if (!freeWeeksReason || freeWeeksReason.trim() === "") {
                formIsValid = false;
                error["freeWeeksReason"] = "Reason for extension is required!";
            }
        } else {
            if (itemDetails.weeksToExtend <= 0) {
                formIsValid = false;
                error["weeksToExtend"] = "# Weeks to Extend must be > 0!";
            }

            if (itemDetails.amount <= 0) {
                formIsValid = false;
                error["amount"] = "Amount must be > 0!";
            }
        }

        setErrors(error);

        return formIsValid;
    }

    const save = () => {
        if (validate()) {
            if (saveDisabled) {
                return;
            }
            setSaveDisabled(true);

            if (extendFree) {
                saveExtendFree();
            } else {
                saveExtend();
            }
        } else {
            toast.error("Fix errors on screen before saving!");
        }
    }

    const saveExtendFree = async () => {
        let freeNoDays = extendPeriod === 1 ? freeWeeks * 7 : freeDays;

        var extendItemDetails = {
            jobId: itemDetails.jobId,
            jobQuoteItemId: itemDetails.jobQuoteItemId,
            freeDays: freeNoDays,
            reason: freeWeeksReason
        };

        var jsonItem = JSON.stringify(extendItemDetails);

        const apiUrl = "SaveExtendFreeScheduleItem";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            var resetItem = resetItemDetails();
            setItemDetails(prevState => ({ ...prevState, resetItem }));
            resetScreen();
            toast.success(itemDetails.item + " has been extended successfully!");
            props.saveModal();
        }
    }

    const saveExtend = async () => {
        var extendItemDetails = {
            jobId: itemDetails.jobId,
            scheduleId: props.scheduleId,
            jobQuoteItemId: itemDetails.jobQuoteItemId,
            itemId: itemDetails.itemId,
            quantity: itemDetails.quantity,
            weeksToExtend: itemDetails.weeksToExtend,
            lastInvoiceEndDate: itemDetails.lastInvoiceEndDate,
            adminFee: chargeAdminFee ? itemDetails.adminFee : 0,
            amount: itemDetails.amount,
            purchaseOrderNumber: itemDetails.purchaseOrderNumber
        };

        var jsonItem = JSON.stringify(extendItemDetails);

        const apiUrl = "SaveExtendScheduleItem";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            var resetItem = resetItemDetails();
            setItemDetails(prevState => ({ ...prevState, resetItem }));
            resetScreen();
            toast.success(itemDetails.item + " has been extended successfully!");
            props.saveModal();
        }
    }

    const renderDetails = (
        <Modal show={props.showModal} onHide={hideModal}>
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Extend {itemDetails.item}</Modal.Title>
                <button type="button" className="close modal__close--colour" onClick={hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <div className={itemDetails.typeId === 1 ? "" : "hidden"}>
                    <label className="input-group" htmlFor="extendFree">
                        <span className="label">Extend For Free?</span>
                        <input className="checkbox" type="checkbox" id="extendFree" name="extendFree" checked={extendFree} onChange={(e) => handleExtendFreeChange(e)}></input>
                    </label>
                </div>
                <div className={extendFree ? "" : "hidden"}>
                    <div className="input-group">
                        <label htmlFor="typeId" className="label">Extend Period</label>
                        <input type="radio" className="marginRight10" id="weeks" name="extendPeriod" value={1} checked={extendPeriod === 1} onChange={(e) => handleExtendPeriodChange(e)}></input>
                        <label className="label-small" htmlFor="tier">Weeks</label>
                        <input type="radio" className="marginRight10" id="days" name="extendPeriod" value={2} checked={extendPeriod === 2} onChange={(e) => handleExtendPeriodChange(e)}></input>
                        <label className="label-small" htmlFor="custom">Days</label>
                    </div>

                    <div className={extendPeriod === 1 ? "" : "hidden" }>
                        <span>Select the number of weeks to extend this item by free of charge</span>
                        <label className="input-group" htmlFor="freeWeeks">
                            <span className="label"># Weeks</span>
                            <input className="input textalignright" type="number" min={1} step={1} id="freeWeeks" name="freeWeeks" value={freeWeeks} onChange={(e) => handleFreeWeeksChange(e)}></input>
                        </label>
                        <span className={errors["freeWeeks"] ? "label errors marginLeftLabel" : "hidden"}>{errors["freeWeeks"]}</span>
                    </div>

                    <div className={extendPeriod === 2 ? "" : "hidden"}>
                        <span>Select the number of days to extend this item by free of charge</span>
                        <label className="input-group" htmlFor="freeDays">
                            <span className="label"># Days</span>
                            <input className="input textalignright" type="number" min={1} step={1} id="freeDays" name="freeDays" value={freeDays} onChange={(e) => handleFreeDaysChange(e)}></input>
                        </label>
                        <span className={errors["freeDays"] ? "label errors marginLeftLabel" : "hidden"}>{errors["freeDays"]}</span>
                    </div>

                    <label className="input-group" htmlFor="freeWeeksReason">
                        <span className="label">Reason for extension</span>
                        <textarea className="input allocate__teamnotes" id="freeWeeksReason" name="freeWeeksReason" value={freeWeeksReason} onChange={(e) => handleFreeWeeksReasonChange(e)}></textarea>
                    </label>
                    <span className={errors["freeWeeksReason"] ? "label errors marginLeftLabel" : "hidden"}>{errors["freeWeeksReason"]}</span>
                </div>
                <div className={extendFree ? "hidden" : "" }>
                    <label className="input-group" htmlFor="weeksToExtend">
                        <span className="label"># {itemDetails.itemTypeId === 50 || itemDetails.itemTypeId === 51 ? "Months" : "Weeks"} To Extend</span>
                        <input className="input textalignright" type="number" min={1} step={1} id="weeksToExtend" name="weeksToExtend" value={itemDetails.weeksToExtend} onChange={(e) => handleHirePeriodChange(e)}></input>
                    </label>
                    <span className={errors["weeksToExtend"] ? "label errors marginLeftLabel" : "hidden"}>{errors["weeksToExtend"]}</span>

                    <label className="input-group" htmlFor="purchaseOrderNumber">
                        <span className="label">PO Number</span>
                        <input className="input" type="text" id="purchaseOrderNumber" name="purchaseOrderNumber" value={itemDetails.purchaseOrderNumber} onChange={(e) => handlePoChange(e)}></input>
                    </label>
                </div>

                <label className="input-group" htmlFor="startDate">
                    <span className="label">Start Date</span>
                    <div>{itemDetails.startDateFormatted}</div>
                </label>

                <label className="input-group" htmlFor="endDate">
                    <span className="label">End Date</span>
                    <div>{itemDetails.endDateFormatted}</div>
                </label>

                <div className={extendFree ? "hidden" : ""}>
                    <label className={itemDetails.itemId != 79 && (itemDetails.itemTypeId === 25 || itemDetails.itemTypeId === 26) ? "input-group" : "hidden"} htmlFor="frequency">
                        <span className="label">Frequency</span>
                        <div>{itemDetails.frequency}</div>
                    </label>

                    <label className="input-group" htmlFor="quantity">
                        <span className="label">Quantity</span>
                        <div>{itemDetails.quantity}</div>
                    </label>

                    <label className="input-group" htmlFor="amount">
                        <span className="label">Amount</span>
                        <input className="input" type="number" min="0" step="0.01" id="amount" name="amount" value={itemDetails.amount} onChange={(e) => handleAmountChange(e)}></input>
                    </label>
                    <span className={errors["amount"] ? "label errors marginLeftLabel" : "hidden"}>{errors["amount"]}</span>

                    <label className="input-group" htmlFor="chargeAdminFee">
                        <span className="label label--setsizesm">Charge Admin Fee?</span>
                        <input className="checkbox" type="checkbox" id="chargeAdminFee" name="chargeAdminFee" checked={chargeAdminFee} onChange={(e) => { handleAdminFeeChange(e) }}></input>
                    </label>

                    <label className={chargeAdminFee ? "input-group" : "hidden"} htmlFor="quantity">
                        <span className="label">Admin Fee</span>
                        <div>{itemDetails.adminFeeFormatted}</div>
                    </label>

                    <label className="input-group" htmlFor="quantity">
                        <span className="label makeitbold">Total Invoice Amount</span>
                        <div>{(itemDetails.adminFee + itemDetails.amount).toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 })}</div>
                    </label>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="popup-button--yes" onClick={save}>Save</button>
            </Modal.Footer>
        </Modal>
    )

    let contents = !props.showModal ? "" :
        loading ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );

}

export default JobScheduleExtendPopup;
